import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PublicSelectEnumComponent } from '@componentes/public-select/public-select-enum.component';
import {
  ModeloVariavel,
} from '@modulos/home/submodulos/previsao-numerica-tempo/pages/mapas-de-previsao/enums/modelo-variavel';
import { VarianteVariavelAlturaGeopotencial, VarianteVariavelDivergenciaVento, VarianteVariavelNebulosidade, VarianteVariavelPrecipitacao, VarianteVariavelTemperatura, VarianteVariavelUmidade, VarianteVariavelVento, VarianteVariavelVorticidadeRelativa } from '@modulos/home/submodulos/previsao-numerica-tempo/pages/mapas-de-previsao/enums/modelo-variavel-variante';

@Component({
  selector: 'seira-public-select-variante-variavel',
  templateUrl: './public-select.component.html',
  styleUrls: ['./public-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PublicSelectVarianteVariavelComponent),
    },
  ],
})
export class PublicSelectVarianteVariavelComponent extends PublicSelectEnumComponent {
  override label = 'Variante';
  override notFoundText = 'Nenhuma variante foi encontrada';
  override placeholder = 'Informe a variante desejada';

  constructor() {
    super([
      [ModeloVariavel.PRECIPITACAO, VarianteVariavelPrecipitacao],
      [ModeloVariavel.TEMPERATURA, VarianteVariavelTemperatura],
      [ModeloVariavel.UMIDADE_AR, VarianteVariavelUmidade],
      [ModeloVariavel.VENTO, VarianteVariavelVento],
      [ModeloVariavel.DIVERGENCIA_VENTO, VarianteVariavelDivergenciaVento],
      [ModeloVariavel.VORTICIDADE_RELATIVA, VarianteVariavelVorticidadeRelativa],
      [ModeloVariavel.NEBULOSIDADE, VarianteVariavelNebulosidade],
      [ModeloVariavel.ALTURA_GEOPOTENCIAL, VarianteVariavelAlturaGeopotencial],
      ['', VarianteVariavelPrecipitacao]
    ]);
  }
}
